/** Human-readable ipSCAPE UC state + duration (live presence tiles). */

const MAX_LIVE_STATUS_DURATION_SEC = 86400;

export function formatStatusDuration(sec: number): string {
  const s = Math.max(0, Math.min(MAX_LIVE_STATUS_DURATION_SEC, Math.floor(sec)));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

export function formatIpscapeStatusLabel(status: string, pauseReason?: string | null): string {
  const pause = pauseReason?.trim();
  if (pause) return `Paused — ${pause}`;
  const raw = (status ?? '').trim() || 'Unknown';
  if (raw.length <= 3) return raw.toUpperCase();
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}

/** Match live presence row to configured ipSCAPE agent id (and optional display name). */
export function agentMatchesPresenceTarget(
  agent: { id: string; name: string },
  ipscapeAgentId: string,
  displayName?: string
): boolean {
  const n = parseInt(ipscapeAgentId, 10);
  if (!Number.isNaN(n) && agent.id === `uc-${n}`) return true;
  const name = displayName?.trim();
  if (name && agent.name.localeCompare(name, undefined, { sensitivity: 'base' }) === 0) return true;
  return false;
}
